{
  "componentType": "platform.components.AppWidget",
  "type": "Container",
  "components": [],
  "data": {
    "type": "AppController",
    "name": "Widget1",
    "applicationId": "46b2ad43-5720-41d2-8436-2058979cb53f",
    "controllerType": "controllerType",
    "id": "dataItem-placeholder",
    "metaData": {
      "isPreset": false,
      "schemaVersion": "1.0",
      "isHidden": false
    }
  },
  "style": "appWidget1",
  "activeModes": {}
}
